import React from "react";
import classNames from "classnames";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { useCategoriesById } from "@hooks/useCategoriesById";
import { useIdCopy } from "@hooks/useIdCopy";
import { CategoryIcon } from "../CategoryIcon";
import styles from "./TransactionCategoryColumnContent.module.scss";

interface Props {
    transaction: { categoryId: string };
}

export const TransactionCategoryColumnContent: React.FC<Props> = ({
    transaction,
}) => {
    const categoriesById = useCategoriesById();
    const { getCopyProps } = useIdCopy({ label: "Category" });

    return (
        <div className={classNames(styles.content, styles.withGap)}>
            <div className={styles.iconContainer}>
                <CategoryIcon categoryId={transaction.categoryId} />
            </div>
            <span {...getCopyProps(transaction.categoryId)}>
                <BreakableText
                    text={categoriesById[transaction.categoryId]?.label}
                />
            </span>
        </div>
    );
};
